import { apiVersion } from "settings";

/* Auth */
export const ROOT = "/";
export const LOGIN = "/login";
export const FORGOTTEN_PHONE = "/forgotten-phone";
export const FORGOTTEN_PASSWORD = "/forgotten-password";
export const RESEND_VERIFICICATION = "/resend-verification";
export const VERIFY_EMAIL = "/verify-email";
export const RESET_PASSWORD = "/reset-password";
export const RESET_PHONE = "/reset-phone";
export const TWOFACTOR_REGISTER = "/tfa/register";
export const TWOFACTOR_VERIFY = "/tfa/verify";

/* Dashboard */
export const DASHBOARD_ROOT = "/dashboard";
export const DASHBOARD_MAIN = DASHBOARD_ROOT;
export const DASHBOARD_ACCESS_CONTROL = `${DASHBOARD_ROOT}/access-control`;

// Administrator Only Routes
export const DASHBOARD_ADMIN = `${DASHBOARD_ROOT}/admin`;
export const DASHBOARD_ROLES_PERMISSIONS = `${DASHBOARD_ROOT}/permissions`;
export const DASHBOARD_CONFIGURATION = `${DASHBOARD_ROOT}/configuration`;

export const ABOUT = "/about";

/* Settings */
export const SETTINGS = "/settings";

/* Utility */
export const DOCUMENTATION = `/docs/version/${apiVersion}`;
export const NOT_FOUND = `/not-found`; // For GA

/* References (to other routes) */
export const HOME = DASHBOARD_MAIN;

/* Account View */
export const ACCOUNTS = "/accounts";
export const ACCOUNT = (accountName: string) => {
  return `/account/${accountName}`;
};
export const ACCOUNT_ANALYSIS = (accountName: string, analysisName: string) => {
  return `/account/${accountName}/analysis/${analysisName}`;
};
export const ACCOUNT_TEAM = (accountName: string, teamName: string) => {
  return `/account/${accountName}/team/${teamName}`;
};

/* Other App References */
export const AICON_DUMMY_ROUTE = "/aicon";
export const AICON_APP_ROOT = "/yard/";

/* External Links */
export const AVLINO_ROOT = "https://avlino.com";
